<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light m-0">
    <!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- Header component -->
    <div>
      <HeaderComponent :headerTitle="headerText" />
    </div>
    <!-- Update popup   -->
    <v-row justify="center">
      <v-dialog v-model="updatePopup" persistent max-width="431px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Update Restock Location</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="closeUpdateRestock">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <v-row>
                <v-autocomplete color="primary" v-model="vendor_list" variant="outlined" :items="vendor_list_item" item-title="vendor_name"
                  item-value="vendor_code" label="Location ID" style="max-width: 380px;"></v-autocomplete>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" size="small" color="primary" class="text-none mb-3" @click="closePopup">Cancel</v-btn>
            <v-btn variant="flat" size="small" class="text-none mb-3" @click="submitUpdatePopup"
              :color="!vendor_list || number > 0 ? '' : 'primary'"
              :disabled="!vendor_list || number > 0">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!--  Success messeage popup -->
    <v-row justify="center">
      <v-dialog v-model="successPopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="successPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span> {{ successmessage }}</span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="white" class="text-none mb-3 bg-blue" @click="afterClickOkLoadData">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Data detail popup -->
    <v-row justify="center">
      <v-dialog v-model="datadetailpopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Tag ID: {{ tag_number }}</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="closeItemDataPopup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Article id</span>
                  </v-col>
                  <v-col cols="12" sm="4" md="6">
                    {{ item_details.article_id ? item_details.article_id : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Article Description</span>
                  </v-col>
                  <v-col cols="12" sm="4" md="6">
                    {{ item_details.article_description ? item_details.article_description : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">ASP (₹)</span>
                  </v-col>
                  <v-col cols="12" sm="4" md="6">
                    {{ item_details.asp ? Number(item_details.asp).toLocaleString('en-IN') : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Category</span>
                  </v-col>
                  <v-col cols="12" sm="4" md="6">
                    {{ item_details.category ? item_details.category : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Grade</span>
                  </v-col>
                  <v-col cols="12" sm="4" md="6">
                    {{ item_details.grade ? item_details.grade : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Restock Location</span>
                  </v-col>
                  <v-col cols="12" sm="4" md="6">
                    <a @click="openItemUpdatePopup" style="color: #1976d2;"><u>Update</u></a>
                  </v-col>
                </v-row>
              </div>
            </v-container>

          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Data detail popup in dispatch-->
    <v-row justify="center">
      <v-dialog v-model="dispatchdatadetailpopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Tag ID: {{ tag_number }}</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="closeItemDataPopup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Article id</span>
                  </v-col>
                  <v-col cols="12" sm="4" md="6">
                    {{ item_details.article_id ? item_details.article_id : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Article Description</span>
                  </v-col>
                  <v-col cols="12" sm="4" md="6">
                    {{ item_details.article_description ? item_details.article_description : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">ASP (₹)</span>
                  </v-col>
                  <v-col cols="12" sm="4" md="6">
                    {{ item_details.details && item_details.details.asp ? item_details.details.asp.toLocaleString('en-IN') : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Category</span>
                  </v-col>
                  <v-col cols="12" sm="4" md="6">
                    {{ item_details.category ? item_details.category : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Grade</span>
                  </v-col>
                  <v-col cols="12" sm="4" md="6">
                    {{ item_details.grade ? item_details.grade : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Restock Location</span>
                  </v-col>
                  <v-col cols="12" sm="4" md="6">
                    {{ item_details.restock_location ? item_details.restock_location : '-' }}
                  </v-col>
                </v-row>
              </div>
            </v-container>

          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Filter Popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-insurance" v-model="filteWithSubPopup" persistent max-width="1224px">
        <v-card class="filter_ui">
          <v-card-actions>
            <v-row>
              <v-col>
                <v-text-field color="primary" class="mt-2" v-model="tag_id" hide-details label="Tag ID" variant="outlined" type="text" required
                  style="max-width: 300px; margin-bottom: 26px;">
                </v-text-field>
              </v-col>
              <v-col>
                <v-expansion-panels readonly class="custom-control_outlined mt-2" ref="asppopref" 
                  style="max-width: 300px !important; margin-bottom: 28px; min-height: 52px; margin-left: 10px;">
                  <v-expansion-panel variant="outlined" @click="openASPPopup">
                    <v-expansion-panel-title>
                      <template v-if="min_price && max_price">
                        Min: {{ min_price }}, Max: {{ max_price }}
                      </template>
                      <template v-else>
                        ASP (₹)
                      </template>
                      <template v-slot:actions>
                        <v-icon color="primary">
                          mdi-menu-down
                        </v-icon>
                      </template>
                    </v-expansion-panel-title>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
              <v-col>
                <v-combobox color="primary" v-model="category" :items="category_items" item-title="name" item-value="id" label="Category"
                  multiple variant="outlined" class="ma-2" style="max-width: 300px;" ref="brandAutocomplete"></v-combobox>
              </v-col>
              <v-col>
                <v-combobox color="primary" v-model="grade" :items="Grade_items" item-title="name" item-value="id" label="Grade" multiple
                variant="outlined" class="ma-2" style="max-width: 300px;" ref="gradeAutocomplete"></v-combobox>
            </v-col>
            <v-col>
                <v-autocomplete  color="primary" style="max-width: 290px !important;"
                  v-model="putaway_filter" variant="outlined" :items="puttawayList"
                   label="Putaway Status" class="ma-2">
                </v-autocomplete>
              </v-col>
          </v-row>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn size="small" variant="outlined" class="text-none " color="primary" @click="closeFilterpopup">Cancel</v-btn>
            <v-btn size="small" variant="flat" :color="number > 0 ? 'secondry' : 'primary'" class="text-none " @click="submitApplyFilterFun" :disabled="number > 0">Apply Filter(S)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- ASP popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-asp" v-model="aspFilterpopup" persistent max-width="300px">
        <v-card class="v-card-100">
          <v-card-title>
            <span>ASP (₹)</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="1" sm="4" md="4">
                    <span style="font-weight: 500;">Min</span>
                  </v-col>
                  <v-col cols="2" sm="8" md="8">
                    <v-text-field color="primary" v-model="min_price" hide-details label="Enter Price" variant="outlined"  type="number" required>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" sm="4" md="4">
                    <span style="font-weight: 500;">Max</span>
                  </v-col>
                  <v-col cols="4" sm="8" md="8">
                    <v-text-field color="primary" v-model="max_price" hide-details label="Enter Price" variant="outlined" type="number" required>
                    </v-text-field>
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="outlined" class="mb-3 text-none" size="small" @click="closeAspPopup">Cancel</v-btn>
            <v-btn color="white" variant="flat" class="mb-3 bg-blue text-none" size="small" @click="submitAspPopup">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Item update popup -->
    <v-row justify="center">
      <v-dialog v-model="itemUpdatePopup" persistent max-width="431px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Update Restock Location</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="itemUpdatePopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <v-row>
                <v-autocomplete color="primary" v-model="vendor_list" variant="outlined" :items="vendor_list_item" item-title="vendor_name"
                  item-value="vendor_code" label="Location Id" style="max-width: 380px;"></v-autocomplete>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" size="small" color="primary" class="mb-3" @click="closePopup">Cancel</v-btn>
            <v-btn variant="flat" size="small" class="mb-3" @click="submitItemUpdatePopup"
              :color="!vendor_list || number > 0 ? '' : 'primary'"
              :disabled="!vendor_list || number > 0">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Tabs -->
    <v-card class="v-card-100">
      <v-tabs color="primary" v-model="selected_tab">
        <v-tab ripple style="text-transform:none!important;" @click="loadData(tab, 'tab_clicked')"
          v-for="(tab, index) in tabs" :key="index" class="tab-color">{{ tab }}</v-tab>
      </v-tabs>
    </v-card>
    <v-card-title style="padding: 25px 25px 15px 15px;" class="action-style pb-1">
    <v-row>
      <!-- Search fields -->
      <v-row style="padding: 25px;">
          <v-combobox v-if="active_tab == 'Pending For Approval'" class="text-left mr-4" v-model="select_field" item-title="name" item-value="id" :items="select_field_items" label="Select Field" variant="outlined" style="max-width: 158px;"> </v-combobox>
          <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="restock_search" v-no-edge-space label="Search" style="max-width: 300px;"
          variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
      </v-row>
      <!-- Action buttons -->
      <v-actions style="margin-bottom: 10px; margin-top:4px">
        <v-btn class="ma-2 mt-2 text-none" size="x-large" color="primary" variant="flat" :disabled="(this.selected.length == 0) || $isRelianceClient()" v-if="this.active_tab == 'Pending Restock Location' && isActionAllowed(role)" @click="openUpdatePopup">Update</v-btn>
        <v-btn class="ma-2 mt-2 text-none" variant="flat" size="x-large" v-if="active_tab == 'Pending Restock Location' && $isRelianceClient() && isActionAllowed(role)" :disabled="selected.length == 0 && $isRelianceClient()" @click="downloadDocument" color="primary">Download</v-btn>
        <v-btn class="ma-2 mt-2 text-none" variant="flat" size="x-large" v-if="active_tab == 'Pending Restock Location' && $isRelianceClient() && isActionAllowed(role)"  :disabled="(selected.length != 0) && $isRelianceClient()" @click="navigateToFileUpload" color="primary">Upload</v-btn>
        </v-actions>
      <!-- Filter -->
      <v-expansion-panels v-if="this.active_tab == 'Pending Restock Location'" class="custom-control_outlined m-0 pt-3"
        ref="filterPopupRef" readonly style="max-width: 300px; margin-bottom: 16px; height: 52px;">
        <v-expansion-panel variant="outlined" @click="filterListOfButtons" style="height: 52px;">
          <v-expansion-panel-title>Filter
          </v-expansion-panel-title>
        </v-expansion-panel>
      </v-expansion-panels>
      </v-row>
    </v-card-title>
    <v-layout column>
      <v-col cols="12" style="overflow: auto" class="p-0">
        <v-data-table hover
          density="compact"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          :loading="loading"
          fixed-header
          height="100%"
          :items-per-page="pageSize"
          loading-text="Loading Data... Please wait"
          class="elevation-1"
          return-object
          >
          <template #[`header.disposition_age`]="{ column }">
            <span>{{ column.title }}
              <AgeingTooltip />
            </span>
          </template>
          <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
              <span v-if="header.key == 'tag_number'">
                <a href="#" @click.prevent="itemDetailpopup(item)" style="color: #1976d2 !important; cursor: pointer !important;"><u>{{ item.tag_number }}</u></a>
              </span> 
              <span v-else-if="header.key !== 'tag_number' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else-if="header.key === 'price' && !item.update">
                <span>{{ item.price ? item.price.toLocaleString('en-IN') : "-" }}</span>
              </span>
              <span v-else-if="header.key === 'asp' && !item.update">
                <span>{{ item.asp ? Number(item.asp).toLocaleString('en-IN') : "-" }}</span>
              </span>
              <span v-else>-</span>
            </template>
          <!-- <template #[`item.tag_number`]="{ item }">
            <a @click="itemDetailpopup(item)" style="color: #1976d2;">
              <u> {{ item.tag_number }}</u>
            </a>
          </template> -->
          <!-- <template #[`item.restock_location`]="{ item }">
            <span>{{ item.restock_location ? item.restock_location : "-" }}</span>
          </template> -->
          <!-- <template #[`item.price`]="{ item }">
            <span>{{ item.price ? item.price.toLocaleString('en-IN') : "-" }}</span>
          </template>
          <template #[`item.asp`]="{ item }">
            <span>{{ item.asp ? Number(item.asp).toLocaleString('en-IN') : "-" }}</span>
          </template> -->
          <!-- <template #[`item.order_number`]="{ item }">
            <span>{{ item.order_number ? item.order_number : "-" }}</span>
          </template>
          <template #[`item.chalan`]="{ item }">
            <span>{{ item.chalan && item.chalan != 'NA' ? item.chalan : "-" }}</span>
          </template>
          <template #[`item.grade`]="{ item }">
            <span>{{ item.grade && item.grade != 'NA' ? item.grade : "-" }}</span>
          </template> -->
          <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>
           <div>
                <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
            </div>
  </v-card>
</template>
<script>
  // import $ from 'jquery'
  // import Editor from "@tinymce/tinymce-vue";
  import HeaderComponent from '../../../../commoncomponents/HeaderComponent.vue';
  import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
  // import { securedAxiosInstance, plainAxiosInstance } from '@/backend/axios'
  // import { strict } from 'assert';
  // import { required, minLength, helpers } from 'vuelidate/lib/validators';
  import { moduleAccessFunc,module_that_allowed,signout,isOnlyViewAction } from '@/backend/axios/moduleAccess'
  // import { moduleAccessFunc,module_that_allowed,signout } from '@/backend/axios/moduleAccess';
  export default {
    data() {
      return {
        headerText: "Restock",
        loading: true,
        alert: false,
        alert_type: "success",
        alert_message: "success",
        tabs: [
          "Pending Restock Location",
          "Dispatch",
          "Pending For Approval"
        ],
        active_tab: "Pending Restock Location",
        selected: [],
        restock_search: '',
        filteWithSubPopup: false,
        tag_id: null,
        tag_id_items: '',
        asp: '',
        asp_items: '',
        category: null,
        category_items: '',
        grade: null,
        Grade_items: '',
        headers: [
          { title: "Tag ID", key: "tag_number", width: '12%', align: "start", sortable: false },
          { title: "Article ID", key: "sku_code" },
          { title: "Article Description", key: "item_description" },
          { title: "ASP (₹)", key: "asp" },
          { title: "Category", key: "category" },
          { title: "Grade", key: "grade" }
        ],
        table_data: [],
        page: 1,
        totalPages: 1,
        totalCount: '',
        pageSize: defaultPageSize,
        pageSizes: defaultPageSizes,
        updatePopup: false,
        vendor_list_item: '',
        vendor_list: null,
        restock_ids: [],
        successmessage: '',
        selected_tab: 0,
        successPopup: false,
        tag_number: '',
        item_id: '',
        item_details: [],
        datadetailpopup: false,
        itemUpdatePopup: false,
        number: 0,
        dispatchdatadetailpopup: false,
        aspFilterpopup: false,
        min_price: '',
        max_price: '',
        isFilteringPage: false,
        filterPageNo : 1,
        role:'',
        putaway_filter:null,
        puttawayList:["Pending","Completed"],
        select_field: null,
        select_field_items: [
             {
                "name":"Tag ID",
                "id": "tag_number"
              },
              {
                "name":"IRD",
                "id": "ird_number"
              },
              {
                "name":"Lot ID",
                "id": "lot_id"
              },
              {
                "name":"Publish ID",
                "id": "publish_id"
              },
              {
                "name":"Pending at",
                "id": "pending_at"
              }
        ]
      }
    },
    components: {
      HeaderComponent
    },
    watch: {
      max_price(newVal) {
        if (newVal !== null && newVal < 0) {
          this.max_price = null; // Set to null or any default positive value
        }
      },
      min_price(newVal) {
        if (newVal !== null && newVal < 0) {
          this.min_price = null; // Set to null or any default positive value
        }
      },
      selected(newVal) {
        if (this.active_tab === 'Pending Restock Location') {
          const putawayInward = newVal.filter(insurances => insurances.is_putaway_inwarded === false)
          const isUnderPhysicalInspection = newVal.filter((insurances) => insurances.is_under_physical_inspection === true);
          if (putawayInward.length > 0) {
            this.showAlert("warning", "Please complete Putaway Process");
            this.selected.splice(0);
          }
          if(isUnderPhysicalInspection.length > 0) {
            this.showAlert("warning", "Action on item blocked as it is under cycle count process");
            this.selected.splice(0);
          }
        }

      },
      category(newValue) {
        if (newValue && newValue.length > 0) {
          this.$nextTick(() => {
            this.$refs.brandAutocomplete.internalSearch = '';
          });
        }
      },
      grade(newValue) {
        if (newValue && newValue.length > 0) {
          this.$nextTick(() => {
            this.$refs.gradeAutocomplete.internalSearch = '';
          });
        }
      },
    },
    computed: {
      totalASP() {
        return this.min_price + this.max_price;
      }
    },
    async created() {
      this.scrollToTop();
      this.role = this.$store.state.currentUser.roles[0]
      if(this.role in module_that_allowed && moduleAccessFunc(this.role,'Restock')){
        signout()
        return;
      }
      this.organization_name = this.$store.state.organization_name
      const tab = this.$store.state.active_tab
      if(tab == 'Dispatch'){
        this.selected_tab = 1
        this.loadData('Dispatch')
      } else{
        this.selected_tab = 0
        this.loadData('Pending Restock Location')
      }
    },
    methods: {
      isActionAllowed(){
        return !isOnlyViewAction(this.role, 'Restock')
      },
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      },
      getRequestParams(page, pageSize) {
        let params = {};

        if (page) {
          params["page"] = page;
        }
        if (pageSize) {
          params["size"] = pageSize;
        }
        return params;
      },
      showAlert(alert_type, alert_message) {
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.alertTimeOut();
        this.scrollToTop();
      },
      alertTimeOut() {
        setTimeout(() => {
          this.alert = false;
        }, 3000);
      },
      loadData(tab, tab_action) {
        if (tab_action) {
          this.restock_search = ''
        }
        this.loading = true;
        this.selected = []
        this.active_tab = tab
        this.table_data = []
        this.page = 1
        this.totalPages = 1
        this.filterPageNo = 1
        this.isFilteringPage = false
        this.$store.commit('setActiveTab',{
          'active_tab' : tab
        })
        if (tab == "Pending Restock Location") {
          (this.headers = [
            { title: "Tag ID", key: "tag_number", width: '12%', align: "start", sortable: false, minWidth: "200px" },
            { title: "Article ID", key: "article_id", sortable: true, minWidth: "200px" },
            { title: "Article Description", key: "article_description", sortable: true, minWidth: "200px" },
            { title: "ASP (₹)", key: "asp", sortable: true, minWidth: "200px" },
            { title: "Category", key: "category", sortable: true, minWidth: "200px" },
            { title: "Grade", key: "grade", sortable: true, minWidth: "200px" },
            { title: "Ageing", key:"disposition_age"},
            { title: "Sub-Location", key:"sub_location_name"},
            { title: "IRRD Number", key: "irrd"},
            { title: "IRD Number", key:"ird"},
            { title: "Serial Number ", key: "serial_number" },
          ]);
          this.fetchPendingRestockLoc();
          this.fetchFilterdData();
        }
        if (tab == "Dispatch") {
          (this.headers = [
            { title: "Tag ID", key: "tag_number", width: '12%', align: "start", sortable: false, minWidth: "200px" },
            { title: "Price (₹)", key: "price", sortable: true, minWidth: "200px" },
            { title: "Restock Location", key: "restock_location", sortable: true, minWidth: "200px" },
            { title: "Transfer Order NO.", key: "order_number", sortable: true, minWidth: "220px" },
            { title: "Challan", key: "chalan", sortable: true, minWidth: "200px" },
            { title: "Ageing", key:"disposition_age"},
            { title: "Status", key: "status", sortable: true, minWidth: "200px" },
            { title: "IRRD Number", key: "irrd"},
            { title: "IRD Number", key:"ird"},
            { title: "Serial Number ", key: "serial_number" },
          ]);
          this.fetchDispatchData();
        }
        if(tab == "Pending For Approval"){
        this.headers = [
                    { title: "Location", key: "location"},
                    { title: "IRD", key: "ird" },
                    { title: "Tag ID", key: "tag_number" },
                    { title: "Article ID", key: "article_id" },
                    { title: "Article Description", key: "article_description"},
                    { title: "Lot ID", key: "lot_id" },
                    { title: "Publish ID", key: "publish_id"},
                    { title: "Recovery Benchmark Price", key: "recovery_benchmark_price" },
                    { title: "Serial No.1", key: "serial_number" },
                    { title: "Serial No.2", key: "serial_number2"},
                    { title: "Approval Type", key: "approval_rule_type"},
                    { title: "Pending At", key: "next_approver_details"}
                ];
        this.fetchPendingForApproval();
      }
      },
      fetchPendingRestockLoc() {
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        this.$httpSecured
          .get("/api/v1/warehouse/restocks", { params: { tag_number: this.restock_search, page: params['page'], per_page: params['size'] } })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.restocks
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      fetchDispatchData() {
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        this.$httpSecured
          .get("/api/v1/warehouse/restocks/restock_dispatch_items", { params: { tag_number: this.restock_search, page: params['page'], per_page: params['size'] } })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.warehouse_order_items
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      fetchPendingForApproval() {
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        if(this.restock_search){
          params[this.select_field.id] = this.restock_search.trim()
        }
        this.$httpSecured
          .get("/api/v1/warehouse/restocks?status=pending_approval", { params })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.restocks
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      filterListOfButtons(ev) {
        document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + 'px');
        this.filteWithSubPopup = true;
        this.number = 0;
      },
      closeFilterpopup() {
        this.filteWithSubPopup = false;
        this.min_price = '';
        this.max_price = '';
        this.grade = null;
        this.category = null;
        this.tag_id = '';
        this.putaway_filter = null;
      },
      calculateTotalASP() {
        return this.min_price + this.max_price;
      },
      navigateToFileUpload() {
          this.$store.commit("setLotIds", {
          lotIds: this.headerText,
          inventoryId: "Pending Restock Location",
          action:'first_tab'
        });       
        this.$router.push({ name: "LotFileuploadComm" });
      },
      downloadDocument() {
        const params = {
          status: 'Pending Restock Location',
          ids: [
            this.selected.map(x => parseInt(x.id))
          ]
        };
        this.$httpSecured
          .post("/api/v1/warehouse/restocks/download_restock", params)
          .then(response => {
            if (response.data) {
                const link = document.createElement("a");
                link.href = response.data.url;
                link.target = "_blank";
                link.download = "restock.csv";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.okapproveconfirmpopup = true;
                this.message = this.active_tab + "(CSV File) Downloaded Successfully";
                this.selected = [];
            } else {
              this.loading = false;
              this.selected = [];
            }
          })
          .catch(error => {
            // this.showAlert("error", "Something went wrong from Network" + error);
            this.$toast.error(error.response.data.error);
          });
      },
      handlePageChange(value) {
        this.page = value;
        if(this.isFilteringPage){
          this.filterPageNo = value;
          this.submitApplyFilterFun()
          return;
        }
        if (this.active_tab == 'Pending Restock Location') {
          this.fetchPendingRestockLoc();
        }else if(this.active_tab == 'Pending For Approval'){
          this.fetchPendingForApproval();
        }else {
          this.fetchDispatchData();
        }
      },
      handlePageSizeChange(size) {
        this.pageSize = size;
        this.page = 1
        this.filterPageNo = 1;
        if(this.isFilteringPage){
          this.submitApplyFilterFun();
          return;
        }
        if (this.active_tab == 'Pending Restock Location') {
          this.fetchPendingRestockLoc();
        } else if(this.active_tab == 'Pending For Approval'){
          this.fetchPendingForApproval();
        } else {
          this.fetchDispatchData();
        }
      },
      closePopup() {
        this.updatePopup = false;
        this.number = 0;
        this.vendor_list = null;
        this.itemUpdatePopup = false;
      },
      openUpdatePopup() {
        this.updatePopup = true;
        this.number = 0;
        this.restock_ids = this.selected.map(restocks => restocks.id);
        this.$httpSecured
          .get("/api/v1/warehouse/restocks/get_master_vendor")
          .then(response => {
            if (response.data) {
              this.vendor_list_item = response.data.vendor_masters
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      submitUpdatePopup() {
        this.number++;
        this.$httpSecured.post('/api/v1/warehouse/restocks/create_restock_dispatch_order', {
          "ids": this.restock_ids,
          "status": "Pending Restock Destination",
          "vendor_code": this.vendor_list
        },)
          .then(response => {
            if (response.data) {
              this.updatePopup = false;
              this.successmessage = response.data.message;
              this.vendor_list = '';
              this.successPopup = true;
            } else {
              this.showAlert("error", "No Data Found");
              this.number = 0;
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.error);
            this.number = 0;
            this.loading = false;

          });
      },
      openItemUpdatePopup() {
        this.itemUpdatePopup = true;
        this.number = 0;
        this.restock_ids = this.selected.map(restocks => restocks.id);
        this.$httpSecured
          .get("/api/v1/warehouse/restocks/get_master_vendor")
          .then(response => {
            if (response.data) {
              this.vendor_list_item = response.data.vendor_masters
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      submitItemUpdatePopup() {
        this.number++;
        var item_ids = [];
        item_ids = this.item_id;
        this.$httpSecured.post('/api/v1/warehouse/restocks/create_restock_dispatch_order', {
          "ids": item_ids,
          "status": "Pending Restock Destination",
          "vendor_code": this.vendor_list
        },)
          .then(response => {
            if (response.data) {
              this.itemUpdatePopup = false;
              this.successmessage = response.data.message;
              this.vendor_list = '';
              this.successPopup = true;
            } else {
              this.showAlert("error", "No Data Found");
              this.number = 0;
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.error);
            this.number = 0;
            this.loading = false;

          });
      },
      afterClickOkLoadData() {
        this.successPopup = false;
        this.datadetailpopup = false;
        this.selected = [];
        this.loadData(this.active_tab);
      },
      itemDetailpopup(item) {
        if (this.active_tab == 'Pending Restock Location') {
          this.datadetailpopup = true
          this.tag_number = item.tag_number;
          let str = String(this.tag_number);
          this.tag_number = str;
          this.item_id = item.id;
          this.$httpSecured
            .get(`/api/v1/warehouse/restocks/${this.item_id}`)
            .then(response => {
              if (response.data) {
                this.item_details = response.data.restock
                this.loading = false;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        } else if (this.active_tab == 'Dispatch') {
          this.dispatchdatadetailpopup = true;
          this.tag_number = item.tag_number;
          let str = String(this.tag_number);
          this.tag_number = str;
          this.item_id = item.id;
          this.$httpSecured
            .get(`/api/v1/warehouse/restocks/restock_dispatch_item?id=${this.item_id}`)
            .then(response => {
              if (response.data) {
                this.item_details = response.data.warehouse_order_item
                this.loading = false;
              } else {
                this.loading = false;
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        }

      },
      closeItemDataPopup() {
        this.dispatchdatadetailpopup = false;
        this.datadetailpopup = false;
      },
      openASPPopup() {
        const dialogElement = this.$refs.asppopref.$el;
        const topPosition = dialogElement.getBoundingClientRect().top + 32;
        document.documentElement.style.setProperty('--dialog-ypos1', `${topPosition}px`);
        // document.documentElement.style.setProperty('--dialog-ypos1', (this.$refs.asppopref.$el.getBoundingClientRect().top + 35).toString() + 'px');
        this.aspFilterpopup = true;
      },
      submitAspPopup() {
        if (this.min_price != '' && this.max_price != '') {
          this.aspFilterpopup = false;
        } else if (this.min_price == '' && this.max_price == '') {
          this.aspFilterpopup = true;
        }
      },
      fetchFilterdData() {
        this.$httpSecured
          .get("/api/v1/warehouse/restocks/get_filters_data")
          .then(response => {
            if (response.data) {
              this.category_items = response.data.categories
              this.Grade_items = response.data.grades
              // this.loading = false;
            } else {
              // this.loading = false;
            }
          })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              // this.loading = false;
            });
      },
      closeAspPopup() {
        this.aspFilterpopup = false;
        this.min_price = '';
        this.max_price = '';
      },
      submitApplyFilterFun() {
        this.isFilteringPage = true
        const params = this.getRequestParams(this.page, this.pageSize);
        this.restock_search = '';
        this.$httpSecured
          .get("/api/v1/warehouse/restocks", {
            params: {
              "tag_number": this.tag_id,
              "price_min": this.min_price,
              "price_max": this.max_price,
              "grade": this.grade ? this.grade.map(item => item.id) : [],
              "category": this.category ? this.category.map(item => item.id) : [],
              "putaway": this.putaway_filter,
              page: this.filterPageNo,
              per_page: this.pageSize,
            }
          })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.restocks;
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              this.filteWithSubPopup = false;
              this.min_price = '',
              this.max_price = '',
              this.grade = '',
              this.category = '',
              this.tag_id = ''
              this.putaway_filter = null
              this.loading = false;
              this.selected = [];
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      closeUpdateRestock() {
        this.number = 0;
        this.updatePopup = false;
        this.vendor_list = '';
      }
    }
  }
</script>
<style scoped>
  .v-dialog>.v-card>:has(.v-card__title) {
    overflow-wrap: break-word !important;
  }

  .custom-control_outlined .v-expansion-panel:before {
    box-shadow: none;
  }

  .custom-control_outlined button {
    min-height: 52px;
    border-width: 1px;
    border-color: rgba(0, 0, 0, .42);
    border-style: solid;
  }

  .custom-control_outlined button:focus {
    outline: none;
  }

  .v-dialog:has(.filter-insurance) {
    justify-content: right;
    align-items: baseline;
    top: var(--dialog-ypos);
  }

  .custom-control_outlined-asp .v-expansion-panel:before {
    box-shadow: none;
  }
  .custom-control_outlined-asp button {
    min-height: 52px;
    border-width: 1px;
    border-color: rgba(0, 0, 0, .42);
    border-style: solid;
  }
  .custom-control_outlined-asp button:focus {
    outline: none;
  }
  
  .v-dialog__content:has(.filter-asp) {
    justify-content: center;
    align-items: baseline;
    top: var(--dialog-ypos1);
    left: calc(var(--dialog-ypos1) - 188px);
  }

  .v-card__text>.row>.col hr {
    border-top: 0.5px solid #2D2D2D;
  }

  @media screen and (min-width: 2000px) {
    .v-dialog__content:has(.filter-asp) {
      left: calc(var(--dialog-ypos1) - 93px);
    }

  }

  @media screen and (max-width: 1440px) {
    .v-dialog__content:has(.filter-asp) {
      left: calc(var(--dialog-ypos1) - 422px) !important;
    }
  }

  @media screen and (max-width: 1024px) {
    .v-dialog__content:has(.filter-asp) {
      left: calc(var(--dialog-ypos1) - 460px) !important;
    }
  }

  @media screen and (max-width: 1350px) {
    .v-dialog__content:has(.filter-asp) {
      left: calc(var(--dialog-ypos1) - 471px);
    }
  }

  @media screen and (max-width: 1610px) {
    .v-dialog__content:has(.filter-asp) {
      left: calc(var(--dialog-ypos1) - 349px);
    }
  }
  .item-selected {
    margin-top: 29px;
    position: absolute;
    left: 35%;
  }
  @media (max-height: 1104px) {
    .PaddingItemPerPage{
      padding: 8px !important;
    }
  }
  @media (min-height: 1126px) {
    .PaddingItemPerPage{
      padding: 24px !important;
    }
  }
  .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 315px) !important;
  }
  .filter_ui{
    margin-left: 32px !important;
    margin-top: 12px !important;
 }
</style>
